import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { store } from "./redux/store"; 
import en from './locales/en.json'
import ru from './locales/ru.json'

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ru: { translation: ru },
    },
    lng: 'ru',
    fallbackLng: 'ru',
    interpolation: {
      escapeValue: false,
    },
  })


store.subscribe(() => {
  
  const language = store.getState().language.language;
  i18n.changeLanguage(language); 
});
export default i18n
